import { css } from 'styled-components';

import { TooltipPosition } from './TooltipPosition';
import { TooltipSize } from './TooltipSize';

export const placementStyles = (
  placement: TooltipPosition,
  targetWidth: number,
  size: TooltipSize,
) => {
  const arrowSize = size === 'large' ? 20 : 10;
  const arrowHorizontalOffset = targetWidth < arrowSize ? 20 : 0;

  switch (placement) {
    case 'bottom-center':
      return css`
        transform: translateX(calc(-50% + ${targetWidth / 2}px))
          translateY(${arrowSize}px);
      `;
    case 'bottom-left':
      return css`
        transform: translateX(
            calc(-100% + ${targetWidth}px + ${arrowHorizontalOffset}px)
          )
          translateY(${arrowSize}px);
      `;
    case 'bottom-right':
      return css`
        transform: translateX(-${arrowHorizontalOffset}px)
          translateY(${arrowSize}px);
      `;
    case 'top-center':
      return css`
        bottom: 100%;
        transform: translateX(calc(-50% + ${targetWidth / 2}px))
          translateY(-${arrowSize}px);
      `;
    case 'top-left':
      return css`
        bottom: 100%;
        transform: translateX(
            calc(-100% + ${targetWidth}px + ${arrowHorizontalOffset}px)
          )
          translateY(-${arrowSize}px);
      `;
    case 'top-right':
      return css`
        bottom: 100%;
        transform: translateX(-${arrowHorizontalOffset}px)
          translateY(-${arrowSize}px);
      `;
    default:
      return null;
  }
};
